<template>
  <div class="auto-play-guide-page" v-if="showPlayGuide" @click="hideSelf">
    <div class="auto-play-guide-dialog">
      <div class="top-back"></div>
      <div class="action">
        <div class="label">Good</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "autoplayguidedialog",
    props: {
      showPlayGuide: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      hideSelf() {
        this.$emit('hideAutoPlayGuide')
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .auto-play-guide-page {
    position: fixed;
    width: 100% !important;
    height: 100% !important;
    z-index: 500;
    top: 0;
    left: 0;
    right: 0;
    border-bottom: 0;
    background: #000000;
    opacity: .8;

    .auto-play-guide-dialog {
      .w(461);
      .h(750);
      position: fixed;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);

      .top-back {
        .w(461);
        .h(494);
        background: url(../../assets/imgs/auto-play-guide.png) no-repeat center;
        background-size: contain;
      }

      .action {
        .mt(166);
        .ml(74);
        .w(312);
        .h(88);
        display: flex;
        .border(2, solid, #FEB02D);
        .b-radius(58);

        .label {
          flex: 1;
          text-align: center;
          .fs(38);
          font-family: Gilroy-Medium;
          font-weight: 500;
          color: #FEB02D;
          .lh(88);
        }
      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/widget/autoplayguidedialog.vue